:root {
  --link-color: #107eab;
}

.breadcrumb {
  list-style: none;
  max-width: 1280px;
  margin: 0 auto;
  padding: 1em 2em 0;
}

.breadcrumb li {
  display: inline;
}

.breadcrumb li + li::before {
  padding: 0 0.7rem;
  color: black;
  content: "/";
}

.breadcrumb a {
  text-decoration: none;
  border-bottom: 1px dashed var(--link-color);
}

.breadcrumb li:first-child a {
  text-decoration: none;
  border-bottom: none;
}

.icon {
  font-size: 1.6em;
}
